import { Pipe, PipeTransform } from '@angular/core';
import { Product } from '../models/product';
import { BrandFirstPipe } from './brand-first.pipe';

@Pipe({
  name: 'productName',
  standalone: true,
})
export class ProductNamePipe implements PipeTransform {
  private readonly brandFirst = new BrandFirstPipe();

  transform(product: Product | null | undefined): string {
    if (!product) {
      return 'Unknown';
    }

    const rawName = (product.name || '').trim();
    const brand = this.brandFirst.transform(product).trim();

    // If there is no brand, just return the name or fallback
    if (!brand) {
      return rawName || 'Unknown';
    }

    // Remove brand from name if already contained (case-insensitive word match)
    let cleanedName = rawName;
    if (cleanedName) {
      const escapedBrand = brand.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const regex = new RegExp(`\\b${escapedBrand}\\b`, 'i');
      cleanedName = cleanedName.replace(regex, '').replace(/\s+/g, ' ').trim();
    }

    const finalName = cleanedName || 'Unknown';
    return `${brand} · ${finalName}`;
  }
}

